import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { DocumentRuleCheck, IDocumentRuleCheck } from "@/models/document-rule-check.entity";

export const DocumentRuleCheckDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<
  IDocumentRuleCheck,
  ""
> {
  getIdentifier(entity: IDocumentRuleCheck): string {
    return (entity as IDocumentRuleCheck).id;
  }

  mapEntity(entity: IDocumentRuleCheck): IDocumentRuleCheck {
    return new DocumentRuleCheck(entity);
  }
})();
